import { Select as BaseSelect, SelectProps } from 'antd';
import style from './index.module.scss';
import Paragraph from 'antd/lib/typography/Paragraph';

type TSelect = {
  selectType?: 'primary' | 'secondary';
  label: string;
  options: { id: string | number; label: string }[];
} & SelectProps;

export const Select = ({
  selectType = 'primary',
  label,
  options,
  ...props
}: TSelect) => {
  return (
    <div
      className={`${style.container} ${style[selectType]} ${
        props.className || ''
      }`}
    >
      <BaseSelect {...props} className={`${style.select}`}>
        {options?.map(({ id, label }) => (
          <BaseSelect.Option key={id} value={id}>
            {label}
          </BaseSelect.Option>
        ))}
      </BaseSelect>
      <Paragraph className={style.label}>{label}</Paragraph>
    </div>
  );
};
